import { AssistancesSearchWidget } from '../../widgets/assistances-search/assistancesSearchWidget';
import { WidgetsDeclaration } from '../../shared/interfaces/widgets-declaration';
import '../../shared/services/i18n';

declare let window: WidgetsDeclaration;
window.assistancesSearchWidget = AssistancesSearchWidget;
